import CreditCardRegex from '../utils/credit-card-regex'

export default {

  rules: {
    'credit-card'(element) {
      // Recompile regex every time we run this test because https://stackoverflow.com/a/2851339
      return CreditCardRegex({exact: true}).test(element.value)
    },

    'exact-length'(element, condition) {
      return element.value.length.toString() === condition.toString()
    },

    'phone-number'(element) {
      return /^(\+)?[0-9()\s]*$/g.test(element.value)
    },
  },

  add(key, test) {
    this.rules[key] = test
  },

  remove(key) {
    delete this.rules[key]
  },
}